import { Loader } from "@/server/agent";

export const LoadersActionCreators = {
  setLoaders: (loaders: Loader[]) => ({
    type: "SET_LOADERS" as const,
    payload: loaders,
  }),

  setLoading: (loading: boolean) => ({
    type: "SET_LOADERS_LOADING" as const,
    payload: loading,
  }),
};
